interface ChevronUpIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}

function ChevronUpIcon({
  size = 36,
  className = '',
  onClick = (event) => {},
  ...rest
}: ChevronUpIconProps) {
  return (
    <span className={className} onClick={onClick} {...rest}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.41009 6.91076C9.73553 6.58533 10.2632 6.58533 10.5886 6.91076L15.5886 11.9108C15.914 12.2362 15.914 12.7638 15.5886 13.0893C15.2632 13.4147 14.7355 13.4147 14.4101 13.0893L9.99935 8.67853L5.5886 13.0893C5.26317 13.4147 4.73553 13.4147 4.41009 13.0893C4.08466 12.7638 4.08466 12.2362 4.41009 11.9108L9.41009 6.91076Z'
        />
      </svg>
    </span>
  );
}

export default ChevronUpIcon;
